import { Routes, Route } from 'react-router-dom';
import AnimationProvider from './providers/AnimationProvider.jsx';
import PageTransitionOverlay from './components/shell/PageTransitionOverlay.jsx';
import MagneticCursor from './components/shell/MagneticCursor.jsx';
import ScrollToTop from './components/shell/ScrollToTop.jsx';
import Home from './pages/Home.jsx';
import Photography from './pages/Photography.jsx';
import Videography from './pages/Videography.jsx';
import NotFound from './pages/NotFound.jsx';

export default function App() {
  return (
    <AnimationProvider>
      <MagneticCursor />
      <ScrollToTop />
      <PageTransitionOverlay />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/photography" element={<Photography />} />
        <Route path="/videography" element={<Videography />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AnimationProvider>
  );
}
